import { jsx, jsxs } from "react/jsx-runtime";
import "./base-provider-Blng6qFC.js";
function MeasMissingParametersScreen({
  missingParams,
  title = "Following query parameters are missing:"
}) {
  return /* @__PURE__ */ jsx("div", { className: "meas-host--full-screen", children: /* @__PURE__ */ jsx("div", { className: "meas-container--vh-centered", children: /* @__PURE__ */ jsxs("div", { className: "meas-content--500-centered meas-text--centered", children: [
    /* @__PURE__ */ jsx("div", { className: "title-02-regular", children: title }),
    /* @__PURE__ */ jsx("div", { className: "title-02-medium", children: missingParams.join(", ") })
  ] }) }) });
}
export {
  MeasMissingParametersScreen as M
};
